var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-form",
        [
          _c("gg-text-field", {
            attrs: {
              disabled: "",
              label: "Current Email",
              "hide-details": "",
              value: _vm.cronEmail
            }
          }),
          !_vm.showEmail
            ? _c(
                "a",
                {
                  staticClass: "my-2 d-flex",
                  attrs: {
                    href: "#"
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      _vm.showEmail = true
                    }
                  }
                },
                [_vm._v("Update Email")]
              )
            : [
                _c("gg-text-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        cron_email: _vm.accountUser
                      },
                      expression: "{ cron_email: accountUser }"
                    }
                  ],
                  staticClass: "mt-4",
                  attrs: {
                    label: "New Email",
                    name: "New Email",
                    "error-messages": _vm.errors.collect("New Email")
                  },
                  model: {
                    value: _vm.newEmail,
                    callback: function callback($$v) {
                      _vm.newEmail = $$v
                    },
                    expression: "newEmail"
                  }
                }),
                _c(
                  "gg-btn",
                  {
                    staticClass: "ml-0",
                    attrs: {
                      tile: "",
                      dark: _vm.canSubmit,
                      disabled: !_vm.canSubmit,
                      loading: _vm.loading
                    },
                    on: {
                      click: _vm.updateEmailDialog
                    }
                  },
                  [_vm._v("Update Email ")]
                )
              ]
        ],
        2
      ),
      _c("confirmation-dialog", {
        ref: "dialog",
        attrs: {
          text:
            "Are you certain that you do NOT wish to receive emails when a cron job runs?"
        },
        on: {
          confirmed: _vm.updateEmail
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }